const MINUTES_IN_HOUR = 60;
const ORIGINAL_SELECTOR = '[data-time="original"]';
const CLONE_SELECTOR = '[data-time="clone"]';

class BookingTimeInput {
  constructor(container) {
    $(container).on('dp.change', ORIGINAL_SELECTOR, event => {
      const time = event.date;
      const minutesFromMidnight =
        time.get('hour') * MINUTES_IN_HOUR + time.get('minute');

      $(`${CLONE_SELECTOR}`)
        .filter(`[name='${event.target.name}']`)
        .val(minutesFromMidnight);
    });
    if ($(container).find(ORIGINAL_SELECTOR).length > 0) {
      $(container)
        .find(ORIGINAL_SELECTOR)
        .trigger('change');
    }
  }
}

export default BookingTimeInput;



// WEBPACK FOOTER //
// ./src/javascripts/BookingTimeInput.js